<label [attr.aria-label]="tooltip" data-microtip-position="top" role="tooltip">
  <button class="clipboard-copy-icon" [tabindex]="0" forcedEnabledMode="none" (click)="onClick()">
    <fa-icon class="fa-lg icon-color" [icon]="iconCopy" size="1x"></fa-icon>
  </button>
</label>
